// extracted by mini-css-extract-plugin
module.exports = {"tooltipHandle":"Tooltip-module--tooltipHandle--3nC9L","tooltip":"Tooltip-module--tooltip--1NVwK","tooltipArrow":"Tooltip-module--tooltipArrow--oVJMu"};